// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divider{
  margin:0;
  overflow:hidden;
  font-weight:400;
  color:#424242;
  text-align:center;
}

  .divider__label{
    position:relative;
  }

  .divider__label::before,
    .divider__label::after{
      position:absolute;
      top:50%;
      right:100%;
      width:1000px;
      margin:0 1rem;
      content:'';
      border-top:0.0625rem solid #d4d4d4;
    }

  .divider__label::after{
      right:auto;
      left:100%;
    }

  .divider--loose{
    margin:2rem 0;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
